import { TRIGGER_METADATA } from 'modules/workflows/constants';

type Option = { id: string; label: string; value: string };
// formatting the trigger options for the UI
export const getTriggerTypeOptions = (enabledNodes: string[]) => {
  return enabledNodes
    .reduce((acc: Option[], trigger: string) => {
      const triggerData = TRIGGER_METADATA[trigger];

      return triggerData
        ? [
            ...acc,
            {
              id: trigger,
              label: triggerData.label,
              value: trigger,
            },
          ]
        : acc;
    }, [])
    .sort((a, b) => (a.label < b.label ? -1 : 1));
};
